import { MoonIcon, SunIcon } from "@heroicons/react/24/solid";

export default function DarkModeToggle({ isDark, setIsDark }) {

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      className={`relative w-14 h-8 flex items-center px-1 rounded-full transition-colors duration-300
        ${isDark ? "bg-gray-700" : "bg-gray-300"}`}
      aria-label="Toggle Dark Mode"
    >
      <span
        className={`absolute left-1 transition-all duration-300 ease-in-out transform
          ${isDark ? "translate-x-6" : "translate-x-0"}`}
      >
        <div className="w-6 h-6 bg-white rounded-full shadow-md flex items-center justify-center">
          {isDark ? (
            <MoonIcon className="w-4 h-4 text-gray-800" />
          ) : (
            <SunIcon className="w-4 h-4 text-yellow-400" />
          )}
        </div>
      </span>
    </button>
  );
}
